/**
 * Project : workspace
 * File    : AddressListScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.common.address.list

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.parmartechnologies.commerce.feature.address.viewModel.AddressViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.address.AddressCard
import component.button.DefaultButton
import component.empty.EmptyData
import component.loader.AppLoader
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import navigation.route.account.AccountNavRoute


/**
 * Represents the address list screen class.
 */


class AddressListScreen{
    @Composable
    fun Content() {
        val viewModel = AddressViewModel()
        val addressList = viewModel.allAddress.collectAsState()
        LaunchedEffect(key1 = Unit) {
            viewModel.retrieve()
        }
        Column(modifier = Modifier.fillMaxHeight()) {
            AppLoader(viewModel)
            TopNavBar(
                title = localization().address.addressTitle, NavigationParam(),
                onBackPress = { AppNavigator.shared().goBack() },
                onClickAdd = {

                    AppNavigator.shared().navigate(
                        AccountNavRoute.CREATE_ADDRESS
                    )
                })
            if (addressList.value.isEmpty()) {
                EmptyData(name = "Address", viewModel = viewModel) {

                }
                DefaultButton(
                    title = localization().address.createNewAddress,
                    onClick = {
                        AppNavigator.shared().navigate(
                            AccountNavRoute.CREATE_ADDRESS
                        )
                    },
                    modifier = Modifier.fillMaxWidth()
                )
            } else {
                LazyColumn(
                    contentPadding = PaddingValues(horizontal = 16.dp, vertical = 8.dp),
                    modifier = Modifier
                        .fillMaxHeight()
                        .fillMaxWidth()
                ) {
                    items(
                        items = addressList.value,
                        itemContent = {
                            AddressCard(address = it, onClick = { address ->
                                viewModel.setEditAddress(address)
                                AppNavigator.shared().navigate(
                                    AccountNavRoute.UPDATE_ADDRESS,NavigationParam(address = it)
                                )
                            })
                        })
                }
            }
        }
    }
}